import * as React from 'react';

export const focusRingClassNames = 'rounded-sm focus:outline-none focus:ring-1 focus:ring-focus';

export function useNoFocusRingOnClick() {
  const [focusOutline, setFocusOutline] = React.useState(false);

  const handleKeydown = (event: KeyboardEvent) => {
    const isTabEvent = event.keyCode === 9;
    if (isTabEvent) {
      setFocusOutline(true);
    }
  };
  const handleMousedown = () => {
    setFocusOutline(false);
  };

  //idea from https://www.eventbrite.com/engineering/how-to-fix-the-ugly-focus-ring-and-not-break-accessibility-in-react/
  React.useEffect(() => {
    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('mousedown', handleMousedown);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
      document.removeEventListener('mousedown', handleMousedown);
    };
  }, []);

  return focusOutline;
}
